import React from 'react';
import { StyleProp, Text, TextStyle, TouchableOpacity } from 'react-native';

import styles from './link-button.style';
import { useColors } from '../../hooks';

interface LinkButtonProps {
  text: string;
  onPress: () => void;
  textStyle?: StyleProp<TextStyle>;
  leftComponent?: React.ReactNode;
}

const LinkButton: React.FC<LinkButtonProps> = ({
  text,
  textStyle,
  onPress,
  leftComponent
}: LinkButtonProps) => {
  const colors = useColors();

  return (
    <TouchableOpacity
      style={[styles.container, { backgroundColor: colors.offWhite }]}
      onPress={onPress}
    >
      {leftComponent}
      <Text style={[styles.text, textStyle]}>{text}</Text>
    </TouchableOpacity>
  );
};

export default LinkButton;
